import { useLocation, useRouteLoaderData } from "react-router";
import type { PageData } from "./data";
import { useStore } from "../stores/rootStore";

export function usePageData(): PageData | null {
	const page = useRouteLoaderData("page") as PageData | null | undefined;
	const { auth } = useStore();
	const path = useLocation().pathname;
	return page?.path === path && (page.session.user?.id ?? null) === (auth.user?.id ?? null) ? page : null;
}
